export default __webpack_public_path__ + "static/media/404page.d565f2d8.jpg";